import abraPic from "@/public/images/artists/abra.png";
import { Artist } from "@/types/types";

export const abra = {
  id: "299",
  name: "Abra",
  image: abraPic,
  description: `Abra has a rich, rounded voice with a smoky low end, soft rasp, and an easy, melodic character.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fabra-preview.mp3",
  meta: {
    free: false,
    new: true,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Reggae", "Soul", "Afrobeat", "Unprocessed"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Mid",
      },
      specific: {
        low: 50,
        high: 68,
      },
      sweetSpot: 58,
    },
  },
} as const satisfies Artist;
